export { FacebookRegistrationBare, FacebookRegistration } from './FacebookRegistration';
